import classNames from 'classnames';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { OLAF } from 'HubStyleTokens/colors';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import { CARD_WIDTH, CARD_HEIGHT } from 'automation-ui-flow-core/canvas/graphConstants';
import ActionThemes from 'automation-ui-flow-core/canvas/ActionThemes';
import ActionCardBanner from 'automation-ui-flow-core/canvas/ActionCardBanner';
import { StyledZoomedOutActionCard, StyledZoomedOutActionCardHeader, StyledActionIcon, StyledActionCard, StyledActionCardHeader, StyledActionTypeHeader, StyledActionTitle, StyledStatusText, StyledActionCardBody, StyledActionCardFooter } from 'automation-ui-flow-core/canvas/AutomationBuilderCardStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function AutomationBuilderCard({
  width = CARD_WIDTH,
  height = CARD_HEIGHT,
  headerIcon = 'question',
  headerImage,
  headerTitle = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-flow-core.action-card.draftActionTitle"
  }),
  titleUseTheme = 'default',
  isDisabled,
  disabledDescription,
  TitleAction,
  content,
  isSelected,
  isHighlighted,
  lazyLoad,
  clickable = true,
  showIcon = true,
  statusType = 'success',
  statusText,
  onClick,
  'data-test-id': dataTestId,
  borderStyle,
  bannerText,
  bannerStyle,
  overrideAccentColor,
  layout = 'default',
  showIconCircle = true
}) {
  const {
    accentColor,
    headerBackgroundColor
  } = ActionThemes[titleUseTheme];
  const CardContainer = layout === 'zoomed-out' ? StyledZoomedOutActionCard : StyledActionCard;
  const CardHeader = layout === 'zoomed-out' ? StyledZoomedOutActionCardHeader : StyledActionCardHeader;
  const cardToRender = /*#__PURE__*/_jsx(CardContainer, {
    onClick: onClick,
    disabled: isDisabled || !clickable,
    className: classNames((isSelected || isHighlighted && !borderStyle) && "selected", clickable && "clickable", isDisabled && "disabled", !!borderStyle && "customBorder"),
    $width: width,
    $height: height,
    onMouseDown: e => {
      // Prevent panning the canvas when dragging within a card
      e.nativeEvent.stopImmediatePropagation();
      e.stopPropagation();
    },
    "data-test-id": dataTestId
    // Intentionally changed the prop to lowercase to fix a react warning
    ,
    $borderStyle: borderStyle,
    $scale: layout === 'zoomed-out' ? 2 : 1,
    $backgroundColor: accentColor === null ? OLAF : headerBackgroundColor,
    children: !lazyLoad && /*#__PURE__*/_jsxs(_Fragment, {
      children: [bannerText && bannerStyle && /*#__PURE__*/_jsx(ActionCardBanner, {
        bannerStyle: bannerStyle,
        bannerText: bannerText
      }), /*#__PURE__*/_jsxs(CardHeader, {
        $showIcon: showIcon,
        $accentColor: overrideAccentColor !== null ? overrideAccentColor || accentColor || undefined : undefined,
        children: [showIcon && /*#__PURE__*/_jsx(StyledActionIcon, {
          className: layout === 'zoomed-out' ? 'm-right-2' : 'm-right-3',
          use: titleUseTheme,
          name: headerIcon,
          src: headerImage,
          alt: "" // alt text would be redundant since the action title comes next
          ,
          size: 19,
          showCircle: layout !== 'zoomed-out' && showIconCircle
        }), /*#__PURE__*/_jsxs(StyledActionTypeHeader, {
          children: [/*#__PURE__*/_jsx(StyledActionTitle, {
            className: "m-y-0",
            children: headerTitle
          }), statusText && layout !== 'zoomed-out' && /*#__PURE__*/_jsxs(StyledStatusText, {
            className: "m-top-1",
            children: [/*#__PURE__*/_jsx(UIStatusDot, {
              use: statusType
            }), statusText]
          })]
        })]
      }), layout !== 'zoomed-out' && /*#__PURE__*/_jsx(StyledActionCardBody, {
        $isDisabled: !!isDisabled,
        children: content
      }), /*#__PURE__*/_jsx(StyledActionCardFooter, {
        children: !!TitleAction && /*#__PURE__*/_jsx(TitleAction, {
          focused: false,
          hovered: false,
          titleUse: "oz",
          use: "default"
        })
      })]
    })
  });
  return disabledDescription ? /*#__PURE__*/_jsx(UITooltip, {
    title: disabledDescription,
    placement: "bottom",
    disabled: !isDisabled,
    children: cardToRender
  }) : cardToRender;
}